module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0101.jpg?v=0ef142cd";